<script>
	import Kbw from "../Components/Kbw/Kbw.svelte";
	import { store } from '../store.js';
	import Modal from 'svelte-simple-modal';

	import { onMount } from "svelte";

	import DATA from "../Data/data";

	let loaded = false;

	const pageName = 'konnect';

	let iw, ow;
	let img;
	
	onMount(() => {
		loaded = true;
	});

	function updateBackground() {
		if(!img || !img.src.includes(`${$store.type}`)) {
			img = new Image();
			img.onload = function() {
				store.update(s => ({...s, imageWidth: this.width, imageHeight: this.height}))
			}
			img.src = `/images/${pageName}-${$store.type}.png`;
		}

	}
	
	onMount(() => {		
		updateBackground();

		window.addEventListener('resize', updateBackground);
		
		return () => {
			window.removeEventListener('resize', updateBackground);
		}
	});
</script>
<svelte:window bind:innerWidth={iw} bind:outerWidth={ow} />
{#if loaded}
	
		<div 
			class="wrapper" 
			class:dev={$store.isDev}
			style={`
				margin: auto;
				height: 100vh;
				display: flex;
				background-color: #000;
				`
			}
			>
			<Modal>
				<Kbw />
			</Modal>
		</div>
{/if}

<style>
</style>
